<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="mt-5 ma-2" v-else>
      <v-row>
        <!-- <v-row> -->
        <!-- <v-col cols="8"> -->
        <v-card-title class="ml-4 primary--text"
          ><v-btn @click="back" class="ml-n7 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >Corporate Funds
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Funding Details of Corporate)</span
          ></v-card-title
        >

        <v-spacer></v-spacer>

        <v-btn
          class="navbar white--text mt-4 mr-9 elevation-0"
          dense
          rounded
          @click="opendialog"
          v-if="checkaccessdata.is_maker == true"
        >
          <v-icon>mdi-plus</v-icon>Add Funds
        </v-btn>
        <!-- </v-col> -->
      </v-row>
      <v-row class="mt-8">
        <v-card-text>
          <v-row class="mt-n6">
            <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
              <v-select
                label="Select Payment Mode"
                v-model="paymentModefilter"
                :items="Selectpaymentmode"
                outlined
                return-object
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
              <v-select
                v-model="transectnStatus"
                dense
                item-text="name"
                item-value="value"
                :items="transectionList"
                label="Transaction Type"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
              <v-select
                label="Select Status"
                v-model="statusfilter"
                :items="statusfilteroptions"
                return-object
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" xs="12" xl="1" md="1" lg="1">
              <v-btn small fab text @click="getFundDetails" color="dark">
                <v-icon dark>mdi-filter</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
              <v-text-field
                dense
                shaped
                outlined
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                class="mr-6"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-row>
      <v-row>
        <v-spacer />

        <v-chip class="mr-9 mt-n3" color="primary" outlined label>
          <span class="green--text subtitle-2">
            <b class="primary--text">Corporate Balance :</b>
            MYR {{ $store.getters.get_getCustDetails.funding_balance }}
          </span>
        </v-chip>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12" sm="12" xs="12" xl="12" md="12" lg="12">
          <v-data-table
            :headers="headers"
            :items="fundListBank"
            :search="search"
            :no-data-text="Nodata"
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ fundListBank.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:[`item.payment_mode`]="{ item }">
              <span class="caption">{{ item.payment_mode }}</span>
            </template>
            <template v-slot:[`item.request_type`]="{ item }">
              <span class="caption">
                {{ getRequestTypeName(item.request_type) }}
              </span>
            </template>
            <template v-slot:[`item.bank_name`]="{ item }">
              <span v-if="item.bank_name != null" class="caption">{{
                item.bank_name
              }}</span>
              <span v-if="item.bank_name == null" class="caption">--</span>
            </template>
            <template v-slot:[`item.pay_id`]="{ item }">
              <span v-if="item.pay_id != null" class="caption">{{
                item.pay_id
              }}</span>
              <span v-if="item.pay_id == null" class="caption">--</span>
            </template>
            <template v-slot:[`item.date_of_txn`]="{ item }">
              <span class="caption">{{ item.date_of_txn }}</span>
            </template>
            <template v-slot:[`item.initiated_by`]="{ item }">
              <span class="subtitle-2">{{ item.initiated_by }}</span>
              <br />
              <span class="caption">{{ item.initiated_on }}</span>
            </template>
            <template v-slot:[`item.initiated_from`]="{ item }">
              <div v-if="item.initiated_from == 'Corporate'">
                <span v-on="on" class="caption">CORPORATE </span>
              </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status == 1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption orange--text font-weight-medium"
                      >PENDING FOR APPROVAL</span
                    >
                  </template>
                  <span>PENDING FOR APPROVAL</span>
                </v-tooltip>
              </div>
              <div v-if="item.status == 2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption green--text font-weight-medium"
                      >APPROVED</span
                    >
                  </template>
                  <span>APPROVED</span>
                </v-tooltip>
              </div>
              <div v-if="item.status == 3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="caption red--text font-weight-medium"
                      >REJECTED</span
                    >
                  </template>
                  <span>REJECTED</span>
                </v-tooltip>
              </div>
              <div v-if="item.status == 5">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="caption red--text font-weight-medium"
                      >PAYMENT FAILED</span
                    >
                  </template>
                  <span>PAYMENT FAILED</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.View`]="{ item }">
              <span>
                <v-icon
                  small
                  class="ml-2"
                  @click="showContent(item)"
                  v-on="on"
                  color="primary"
                  >mdi-eye</v-icon
                ></span
              >
            </template>
            <template v-slot:[`item.approved_on`]="{ item }">
              <span class="subtitle-2">{{ item.approved_by }}</span>
              <br />
              <span class="caption">{{ item.approved_on }}</span>
              <span class="subtitle-2" v-if="item.approved_on == null">-</span
              ><br />
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <span class="caption">{{ item.amount }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="contentDialog" max-width="600">
      <v-card>
        <v-toolbar flat class="header" dense dark>
          <v-icon>mdi-cash-multiple</v-icon>
          <span class="ml-3">Fund Details</span>

          <v-spacer></v-spacer>
          <v-btn class text dark @click="contentDialog = false">
            <v-icon small color="white" class="ml-8"> mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card
            elevation="1"
            width="600"
            height="auto"
            class="mb-4 mt-6"
            shaped
          >
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Corporate Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.corp_name != null"
                    >
                      {{ contentDetails.corp_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Initiated By</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.initiated_by != null"
                    >
                      {{ contentDetails.initiated_by }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Initiated On</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.initiated_on != null"
                    >
                      {{ contentDetails.initiated_on }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Initiator Remarks</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.initiator_remarks != null"
                    >
                      {{ contentDetails.initiator_remarks }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approved By</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.approved_by != null"
                    >
                      {{ contentDetails.approved_by }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3" v-if="contentDetails.status != 1">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approver Remarks</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.approver_remarks"
                    >
                      {{ contentDetails.approver_remarks }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" lg="6" xl="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Payment Mode</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="contentDetails.payment_mode != null"
                    >
                      {{ contentDetails.payment_mode }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Amount(MYR)</b>
                    </span>
                    <br />
                    <span class="caption" v-if="contentDetails.amount != null">
                      {{ contentDetails.amount }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Transaction Type</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="
                        getRequestTypeName(contentDetails.request_type) != null
                      "
                    >
                      {{ getRequestTypeName(contentDetails.request_type) }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Reference No</b>
                    </span>
                    <br />
                    <span class="caption" v-if="contentDetails.pay_id != null">
                      {{ contentDetails.pay_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row
                  class="ml-3"
                  v-if="contentDetails.payment_mode == 'CHEQUE'"
                >
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Cheque Number</b>
                    </span>
                    <br />
                    <span class="caption" v-if="contentDetails.pay_id != null">
                      {{ payDetails.pay_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row
                  class="ml-3"
                  v-if="contentDetails.payment_mode == 'Bank Transfer'"
                >
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Txn ID</b>
                    </span>
                    <br />
                    <span class="caption" v-if="payDetails.pay_id != null">
                      {{ payDetails.pay_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Bank Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="payDetails.bank_info">
                      {{ payDetails.bank_info.bank_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openpaymentoptions" width="800" persistent>
      <v-card class="overflow-hidden">
        <v-toolbar dark dense class="header" flat>
          <v-icon>mdi-bank</v-icon>
          <span class="ml-3">Payment Options</span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="close()">
            <v-icon color="white" class="subtitle-2" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row class="ml-n9">
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
              <v-btn
                :class="{ grey: activeTab === 'banktransfer' }"
                width="400px"
                @click="setActiveTab('banktransfer')"
              >
                BANK TRANSFER
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
              <v-btn
                :class="{ orange: activeTab === 'fpx' }"
                width="400px"
                @click="setActiveTab('fpx')"
              >
                FPX
              </v-btn>
            </v-col>
          </v-row>

          <v-card
            height="auto"
            v-if="activeTab === 'banktransfer'"
            class="mt-2"
            outlined
          >
            <v-card-text>
              <v-row class="ml-1">
                <span
                  justify="center"
                  style="font-size: 13px"
                  align="center"
                  class="black--text"
                  >Please transfer funds from your Company's registered bank
                  account to the following bank account and then submit
                  details</span
                >
              </v-row>

              <v-row class="ml-1">
                <span class="grey--text"><b>ACCOUNT NAME</b> : </span>
                <span class="primary--text">
                  Instapay Technologies Sdn Bhd</span
                ></v-row
              >
              <v-row class="ml-1">
                <span class="grey--text"><b>ACCOUNT NUMBER</b> : </span>
                <span class="primary--text">3230126300</span></v-row
              >
              <v-row class="ml-1">
                <span class="grey--text"><b>BANK NAME</b> : </span>
                <span class="primary--text"> Public Bank</span>
              </v-row>

              <v-form ref="fund1Form">
                <v-row class="ml- mr- mt-4">
                  <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                    <v-text-field
                      v-model="paymentMode"
                      label=" Payment Mode *"
                      outlined
                      dense
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" lg="8" xl="8" md="8" sm="12" xs="12">
                    <v-select
                      label="Select Bank Name *"
                      :items="listOfBankDetails"
                      v-model="banknamedetails"
                      item-text="name"
                      :hint="searchHint"
                      persistent-hint
                      @input="getHint(banknamedetails)"
                      item-value="bank_details"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Required']"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="4"
                    xl="4"
                    md="4"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-text-field
                      v-model="amount"
                      maxlength="8"
                      :rules="amountrules"
                      color="primary"
                      label="Amount(RM) *"
                      required
                      outlined
                      dense
                      @keypress="isNumber(event)"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="4"
                    xl="4"
                    md="4"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      color="primary"
                      :return-value.sync="date_of_transaction"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date_of_transaction"
                          dense
                          outlined
                          hint="YYYY/MM/DD"
                          persistent-hint
                          label="Date of Transaction"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          :rules="[(v) => !!v || 'Required']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 10)"
                        v-model="date_of_transaction"
                        color="primary"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(date_of_transaction)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="4"
                    xl="4"
                    md="4"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <!-- <v-text-field
                      v-if="item === 'CHEQUE'"
                      v-model="chequenumber"
                      color="primary"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9@._%+-]{0,10}$)[0-9 +-]{0,64}$/.test(
                            v
                          ) || 'Invalid',
                        (v) => (v && v.length < 11) || 'Invalid Check Number',
                      ]"
                      maxlength="10"
                      label="Cheque Number *"
                      required
                      outlined
                      dense
                    ></v-text-field> -->
                    <v-text-field
                      dense
                      v-model="chequenumber"
                      label="Enter Bank Txn ID"
                      outlined
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^[a-zA-Z0-9]*$/.test(v) ||
                          'Speacial characters not allowed',
                      ]"
                      required
                      maxlength="36"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-textarea
                      dense
                      rows="1"
                      outlined
                      label="Remarks *"
                      v-model="comments"
                      :rules="[(v) => !!v || 'Required']"
                    ></v-textarea>
                  </v-col>
                  <!-- <v-col cols="12" md="6" class="mt-n5">
                    <v-file-input
                      v-model="file"
                      clearable
                      label="Upload Document"
                      dense
                      @change="beforeaddingfile()"
                      class="mr-3"
                      outlined
                    >
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n5">
                    <v-row class="mt-n3">
                      <v-col cols="12">
                        <v-list dense class="mt-n4">
                          <v-list-item
                            v-for="(item, i) in new_array"
                            :key="i"
                            class="mt-n2"
                            dense
                          >
                            <v-list-item-icon class="mr-n2">
                              <v-icon
                                class="primary--text ml-5 mr-5 mt-2"
                                x-small
                                >mdi-circle-slice-8</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="mt-2">
                                {{ item.fileName }}</v-list-item-title
                              >

                              <v-icon
                                small
                                class="mt-n5"
                                style="margin-left: 80px"
                                color="red"
                                @click="deleteItem(item)"
                                >mdi-close</v-icon
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions class="mt-n8">
              <v-spacer></v-spacer>
              <v-btn
                dark
                rounded
                class="primary elevation-6 mt-n1 mr-3"
                medium
                :loading="loadingSubmit"
                @click="submitFund()"
              >
                Submit
              </v-btn>
            </v-card-actions></v-card
          >
          <v-card height="auto" v-if="activeTab === 'fpx'" class="mt-2">
            <v-card-text justify="center" align="center" class="mt-4">
              <v-row justify="center" align="center">
                <span class="font-weight-bold text"
                  >Enter Amount and Click on Continue for Online Banking.
                </span>
              </v-row>

              <!-- Remove the v-form from here -->
              <v-row class="mt-8">
                <v-col lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-text-field
                    v-model="cardorfpxamount"
                    label="Amount *"
                    :rules="fpxAmountrules"
                    outlined
                    dense
                    @keypress="isNumber(event)"
                    maxlength="8"
                    @keydown.space="preventLeadingSpace"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                dark
                rounded
                class="primary theme--light elevation-12 mt-n3"
                medium
                :loading="loadingSubmit"
                @click="validateAndOpenEGHLPage()"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <page ref="paymentGateway" />
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>
<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";

import page from "@/Views/Payments/page.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
    page,
  },
  data: () => ({
    activeTab: "banktransfer",
    count: 0,
    fpxAmountrules: [(v) => !!v || "Required"],
    amountrules: [(v) => !!v || "Required"],
    searchHint: "",
    search: "",
    contentDetails: {},
    on: "",
    overlay: false,
    loadingSubmit: false,
    rules: {
      amount: [(v) => !!v || "Required"],
    },
    comments: "",
    chequenumber: "",
    openpaymentoptions: false,
    opencarddialog: false,
    Selectpaymentmode: [
      { text: "All", value: 0 },
      { text: "Cheque", value: 1 },
      { text: "Bank Transfer", value: 2 },
      { text: "Card", value: 3 },
      { text: "FPX", value: 4 },
    ],
    modal: false,
    date_of_transaction: new Date().toISOString().substr(0, 10),
    amount: "",
    banknamedetails: "",
    paymentMode: "BANK TRANSFER",
    paymentModefilter: { text: "All", value: "0" },
    chequenumberCHEQUE: "",
    tab: null,
    statusfilter: { text: "All", value: "0" },
    statusfilteroptions: [
      { text: "All", value: "0" },
      { text: "Pending for approval", value: "1" },
      { text: "Approved", value: "2" },
      { text: "rejected", value: "3" },
    ],
    chequenumberBANK: "",
    paymentModeList: ["BANK TRANSFER", "FPX"],
    RequestFunds: false,
    cardorfpxamount: "",
    transectnStatus: 0,
    contentDialog: false,
    payDetails: {},
    transectionList: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "Card Pack Fee",
        value: 1,
      },
      {
        name: "Monthly Subscription Fee",
        value: 2,
      },
      {
        name: "Annual Subscription Fee",
        value: 3,
      },
      {
        name: "Funding - Bank Transfer",
        value: 4,
      },
      {
        name: "Funding - Cheque Deposit",
        value: 5,
      },
      {
        name: "Funding - FPX",
        value: 6,
      },
      {
        name: "Funding - JomPay",
        value: 7,
      },
      {
        name: "Funding - Card",
        value: 8,
      },
      {
        name: "Debit Adjustment",
        value: 9,
      },
      {
        name: "Refund to Bank",
        value: 10,
      },
      {
        name: "Pay to Card",
        value: 11,
      },
      {
        name: "Reverse from Card",
        value: 12,
      },
    ],
    headers: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        width: "50px",
        sortable: false,
      },
      {
        text: "INITIATED BY/ON",
        value: "initiated_by",
        width: "50px",
        sortable: false,
      },
      {
        text: "INITIATED FROM",
        value: "initiated_from",
        width: "50px",
        sortable: false,
      },
      {
        text: "APPROVED BY/ON",
        value: "approved_on",
        width: "50px",
        sortable: false,
      },
      {
        text: "PAYMENT MODE",
        value: "payment_mode",
        width: "50px",
        sortable: false,
      },
      // {
      //   text: "Bank Name",
      //   value: "bank_name",
      //   width: "50px",
      // },
      // {
      //   text: "#Ref No.",
      //   value: "pay_id",
      //   width: "100px",
      // },
      {
        text: "TRANSACTION TYPE",
        align: "left",
        value: "request_type",
        width: "100px",
        sortable: false,
      },
      // {
      //   text: "Date of Transaction",
      //   value: "date_of_txn",
      //   width: "40px",
      // },
      {
        text: "AMOUNT(MYR)",
        value: "amount",
        width: "50px",
        sortable: false,
      },

      {
        text: "STATUS",
        value: "status",
        width: "50px",
        sortable: false,
      },
      {
        text: "VIEW",
        value: "View",
        width: "50px",
        sortable: false,
      },
    ],

    listOfBankDetails: [],
    fundListBank: [],
    searchText: "",
    // fund1Form1: "",
    checkaccessdata: {},
    Nodata: "",

    file: "",
    fileslist: [],
    filename: "",
    new_array: [],
    fileorg: {},
    mediaUrls: [],
    NewUrl: "",
    fileList: [],
    cardcount: 0,
  }),
  watch: {
    openpaymentoptions(val) {
      if (val == true) {
        this.activeTab = "banktransfer";
      }
    },
    // activeTab(val) {
    //   console.log(val);
    //   if (val == "fpx") {
    //     this.amountrules = [];
    //   }
    // },
    //   tab(val) {
    //     if (val == 0) {
    //       this.amountrules = [];
    //       this.$refs.form1.resetValidation();
    //     }
    //   },
    //   // opendialog(val) {
    //   //   if (val == true) {
    //   //     this.amountrules = [];
    //   //     this.$refs.fund1Form.resetValidation();
    //   //   }
    //   // },
  },
  // sdljn
  created() {
    this.paymentModefilter.value = 0;

    this.checkaccess();
    //   console.log("store", this.$store.getters.get_dialogcheck);
    if (this.$store.getters.get_dialogcheck == true) {
      this.openpaymentoptions = true;
    }
  },

  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CFUNDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getuserdeatils();
        this.getFundDetails();
        this.getbankDetails();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    getRequestTypeName(requestType) {
      let filteredValue = this.transectionList.filter(
        (item) => item.value == requestType
      );
      if (filteredValue.length > 0) {
        return filteredValue[0].name;
      } else {
        return "";
      }
    },
    //  getRequestName(text) {
    //   var returnValue;
    //   var self = this;

    //   self.transectionList.forEach(function (ele) {
    //     if (ele.value == text) {
    //       returnValue = ele.name;
    //     }
    //   });
    //   return returnValue;
    // },
    async getuserdeatils() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var rowlist = responseData.data.data;
          this.$store.commit("SET_Cusdetails", rowlist);
        }
      }
      //  console.log("getuserdeatils", responseData);
    },
    closedialog() {
      this.paymentMode = "BANK TRANSFER";
      this.chequenumber = "";
      this.amount = "";
      this.modal = false;
      this.date_of_transaction = new Date().toISOString().substr(0, 10);
      this.banknamedetails = "";
      this.comments = "";
      this.searchHint = "";
      this.rules = "";
      this.RequestFunds = false;
    },
    showContent(item) {
      this.contentDialog = true;
      this.contentDetails = item;
      // console.log(this.contentDetails, " this.contentDetails");
      // if (this.reason !== "") {
      //   this.$refs.form.reset();
      // }
      // this.otpReset();
      // this.contentDialog = true;
      // this.contentDetails = item;
      // // console.log(this.contentDetails, "contentDetails");
      if (this.contentDetails.payment_detail != undefined) {
        this.payDetails = this.contentDetails.payment_detail;
      }
    },
    paymentmodedialog() {
      //  console.log(this.paymentMode);
      //  ["CHEQUE", "BANK TRANSFER","CARD","FPX"],
      if (this.paymentMode == "CHEQUE") {
        this.RequestFunds = true;
      } else if (this.paymentMode == "BANK TRANSFER") {
        this.RequestFunds = true;
      } else if (this.paymentMode == "CARD") {
        this.opencarddialog = true;
      } else if (this.paymentMode == "FPX") {
        this.opencarddialog = true;
      }
    },

    openpaymentpage() {
      this.$refs.paymentGateway.redirect = true;
    },
    opendialog() {
      // (this.rules = {
      //   amount: [(v) => !!v || "Required"],
      // }),

      this.openpaymentoptions = true;
      this.paymentMode = "BANK TRANSFER";
      this.tab = 0;
      // this.RequestFunds = true;
    },
    getHint(getValue) {
      //    console.log(getValue);
      this.searchHint =
        "Acct Name : " +
        getValue.account_name +
        ", " +
        "Acct No. : " +
        getValue.bank_account_num;
    },
    convertDate(dateValue) {
      if (dateValue == null) {
        return "";
      } else {
        return moment(dateValue).format("YYYY-MM-DD");
      }
    },
    validateAndOpenEGHLPage() {
      // Validate the form here
      if (this.validateFPXAmount()) {
        // Validation passed, proceed with opening the EGHL page or other actions
        this.openEGHLPage();
      }
    },
    validateFPXAmount() {
      const amount = this.cardorfpxamount;
      const rules = this.fpxAmountrules;

      let validationPassed = true; // Assume validation is initially passed

      for (const rule of rules) {
        const result = rule(amount);
        if (result !== true) {
          // Display an error message for the first failed rule (you can handle this part as needed)
          // this.$toast.error(result);

          // Set validationPassed to false because validation failed
          validationPassed = false;
        }
      }

      if (validationPassed) {
        // All validation rules passed, return true
        return true;
      } else {
        // Display a custom error message for all failed rules
        this.$store.commit("snackbar/showMessage", {
          content: "Please fill all the mandatory fields",
          color: "red",
        });
        return false;
      }
    },

    openEGHLPage() {
      var paymentmode = "";
      if (this.paymentMode == "CARD") {
        paymentmode = "CC";
      } else if (this.paymentMode == "FPX") {
        paymentmode = "DD";
      }

      this.openpaymentoptions = false;
      this.$refs.paymentGateway.redirect = true;
      // this.count = 1;
      // console.log("paymentmode*****", this.paymentMode);
      // console.log("paymentmode*****", paymentmode);
      this.$refs.paymentGateway.getCallfororderId(
        this.cardorfpxamount,
        null,
        paymentmode
      );
    },
    async getFundDetails() {
      // console.log(
      //   "this.paymentModefilter.value,",
      //   this.paymentModefilter.value
      // );
      // console.log("this.paymentModefilter.value,", this.statusfilter.value);
      // this.overlay = true;
      var inputData = {
        method_name: "CFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GET",
          corp_id: this.$store.getters.get_corpid,
          search_text: this.search,
          payment_mode: this.paymentModefilter.value,
          request_type: this.transectnStatus,
          status: this.statusfilter.value,
          initiated_from: "2",
          type: 1,
        },
      };

      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.fundListBank = responseData.data.data;
        this.fundListBank.forEach(function (ele) {
          ele.date_of_txn = ele.payment_detail.date_of_txn;
          ele.pay_id = ele.payment_detail.pay_id;
          ele.bank_name =
            ele.payment_detail.bank_info == null
              ? null
              : ele.payment_detail.bank_info.bank_name;
        });
        this.overlay = false;
        //  console.log("fundListBank", this.fundListBank);
      } else if (responseData.data.status == "NOREC") {
        this.fundListBank = [];
        this.overlay = false;
        this.Nodata = responseData.data.status_msg;
      } else {
        this.overlay = false;
      }
      this.overlay = false;
    },
    close() {
      this.banknamedetails = null;
      this.chequenumber = null;
      this.amount = null;
      this.comments = null;
      this.searchHint = null;
      this.cardorfpxamount = null;
      this.openpaymentoptions = false;
      this.opencarddialog = false;
      this.contentDialog = false;
      this.$refs.form1.reset();
      this.$refs.fund1Form.reset();
      this.new_array = [];
    },
    tabdata(data) {
      //   console.log("tab", this.tab);
      // alert(20)

      this.paymentMode = data;
      this.banknamedetails = "";
      this.chequenumber = "";
      this.amount = "";
      this.comments = "";
      this.searchHint = "";
      this.cardorfpxamount = "";
    },
    deleteItem(item) {
      this.editedIndex = this.new_array.indexOf(item);
      // this.fileList.splice(this.indexOfItemToDelete, 1);
      this.new_array.splice(this.editedIndex, 1);
    },

    async submitFund() {
      if (this.$refs.fund1Form.validate()) {
        this.uploadFile();
        var row = {
          acct_type: this.banknamedetails.account_type,
          acct_name: this.banknamedetails.account_name,
          bank_name: this.banknamedetails.bank_name,
          acct_no: this.banknamedetails.bank_account_num,
        };
        // console.log(row);
        // if (this.$refs.fundForm.validate()) {
        for (let i = 0; i < this.new_array.length; i++) {
          this.NewUrl = this.new_array[i].fileUrl;
          this.mediaUrls.push(this.NewUrl);
        }
        // console.log("mediaUrls", this.mediaUrls);
        this.loadingSubmit = true;
        var inputData = {
          method_name: "CFUND",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CREATE",
            corp_id: this.$store.getters.get_corpid,
            payment_mode: this.paymentMode == "CHEQUE" ? 1 : 2,
            request_type: this.paymentMode == "CHEQUE" ? 5 : 4,
            payment_detail: {
              bank_info: row,
              pay_id: this.chequenumber,
              date_of_txn: this.date_of_transaction,
            },
            initiated_by: this.$store.getters.get_userid,
            amount: this.amount,
            comments: this.comments,
            fund_type: 1,
          },
        };
        var responseData = await apiCall(inputData);
        // console.log("wew", responseData);
        if (responseData.data.status == "00") {
          // this.$store.commit("snackbar/showMessage", {
          //   content: "Successfully Submitted, Pending for Admin Approval",
          //   color: "green",
          // });

          this.RequestFunds = false;
          this.loadingSubmit = false;
          this.openpaymentoptions = false;
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.getFundDetails();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.RequestFunds = false;
          this.loadingSubmit = false;
        }
        this.close();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Please fill all the mandatory fields",
          color: "red",
        });
      }
      // }
    },
    async getbankDetails() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BANKGET",
          corp_id: this.$store.getters.get_corpid,
          search_text: this.searchText,
        },
      };
      var responseData = await apiCall(inputData);

      var resList = responseData.data.data;
      resList.forEach((element) => {
        this.listOfBankDetails.push({
          name: element.bank_name,
          bank_details: element,
        });
      });

      // console.log(this.listOfBankDetails);
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    uploadFile() {
      const self = this;
      this.fileslist.forEach(function (file) {
        self.uploadDoc(file);
      });
    },

    addFile() {
      // this.file = [];
      this.missingDocList = [];
      let docItem = {
        doc_url: this.file,
        docExtn: this.getExtension(this.file.name),
        fileName: this.file.name,
        size: this.file.size,
        doc_type: 1,
        doc_id: 0,
      };
      var reader = new FileReader();

      if (
        this.getExtension(this.file.name) == "jpeg" ||
        this.getExtension(this.file.name) == "jpg" ||
        this.getExtension(this.file.name) == "JPG" ||
        this.getExtension(this.file.name) == "jpeg" ||
        this.getExtension(this.file.name) == "png" ||
        this.getExtension(this.file.name) == "PNG" ||
        this.getExtension(this.file.name) == "webp" ||
        this.getExtension(this.file.name) == "WEBP"
      ) {
        this.uploadDoc(docItem);
        reader.readAsDataURL(this.file);
        this.file = [];
        this.loadingAdd = false;
      } else {
        this.file = [];
        this.loadingAdd = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Invalid File Format",
          color: "red",
        });
      }
    },

    beforeaddingfile() {
      this.addFile();
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async uploadDoc(docItem) {
      let file = docItem.doc_url;
      var inputData = {
        method_name: "ONUPLOAD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "UPLOAD",
          file_name: docItem.fileName,
          doc_id: 0,
          upload_type: 8,
        },
      };

      var responseData = await apiCall(inputData, file);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.doc_url = responseData.data.data.media_url;

          this.fileList.fileName = this.doc_url.split(
            "https://glydpaysol-uat.oss-ap-southeast-3.aliyuncs.com/CPORTAL/Common/"
          )[1];
          var filenamenew = docItem.fileName;
          var url = this.doc_url;

          // this.filee = this.packageModel(filenamenew, this.doc_url);
          this.packageModel = {
            fileName: filenamenew,
            fileUrl: url,
          };

          this.new_array.push(this.packageModel);

          this.fileList.push(this.doc_url);

          for (let i = 0; i < this.fileslist.length; i++) {
            console.warn(this.fileslist[i]);
          }
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        }
      } else if (responseData.data.status == "INVLDFL") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Entity Too Large",
          color: "red",
        });
      }
    },
    banktransfer() {
      this.changeColor();
      this.cardcount = 0;
    },
    fpx() {
      this.changeColor1();
      this.cardcount = 1;
    },
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
  },
};
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
.v-data-table {
  white-space: nowrap;
}
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
.grey {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
.orange {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
</style>
